export const popup = () => {
  const el = document.querySelector('.popup')
  const close = el?.querySelectorAll('.popup__close, .popup__button')

  if (!el) return

  close.forEach(button => {
    button.addEventListener('click', () => removePopup())
  })

  window.onscroll = function(e) {
    if (this.scrollY > 1000) showPopup()
  }

  const showPopup = () => {
    el.classList.add('visible')
  }
  
  const removePopup = () => {
    el.classList.remove('visible')
    setTimeout(() => el.remove(), 300)
  }
}

export default () => {}